// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3R3El","label":"Completed_label__3Cm77"};